import { compact, countBy, reduce } from 'lodash';
import { ProductBundleSummary, ProductSummaryWithFinishGroups } from '@/types/product';

type Product = Queries.DatoCmsProductSummaryFragment;
type CountedKeys = Record<string, number>;

const getAllCategories = (products: Product[]): CountedKeys =>
  countBy(compact(products.map((product) => product?.pim?.categories).flat()));

const getAllCollections = (products: Product[]): CountedKeys =>
  countBy(compact(products.map((product) => product?.collection?.slug)));

const scoreCategories = (allCategories: CountedKeys, product: Product) =>
  reduce(
    allCategories,
    (accum, count, key) => accum + (product.pim?.categories?.includes(key) ? count : 0),
    0
  );

const scoreCollections = (allCollections: CountedKeys, product: Product) =>
  reduce(
    allCollections,
    (accum, count, key) => accum + (product.collection?.slug === key ? count : 0),
    0
  );

export const findRelated = (products: Product[], allProducts: Product[], limit = 3) => {
  const categories = getAllCategories(products);
  const collections = getAllCollections(products);
  const sorted = allProducts.sort((a, b) => {
    const aScore = scoreCategories(categories, a) + scoreCollections(collections, a);
    const bScore = scoreCategories(categories, b) + scoreCollections(collections, b);
    return bScore - aScore;
  });
  return sorted.slice(0, limit);
};

export const isBundle = (
  product: ProductSummaryWithFinishGroups | ProductBundleSummary | null
): product is ProductBundleSummary =>
  !!(product as ProductBundleSummary)?.bundleOptions?.length;